import request from "@/utils/request";


export default function getAgentCardByPage(params, pageNum = 1, size = 10) {
    return request({
        url: `/user/card/getAgentCardByPage/${pageNum}/${size}`,
        params: params
    })
}